var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_8877)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 11,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.84 15.5957V19.3201C15.8393 19.8193 16.098 20.2834 16.5227 20.5456C16.9474 20.8086 17.4776 20.8325 17.9241 20.6089L19.3641 19.8889C19.852 19.6449 20.1607 19.1457 20.16 18.6001V15.5957L22.6188 13.1391C22.8888 12.8691 23.04 12.502 23.04 12.1202V10.6802C23.04 10.2984 22.8881 9.93212 22.6181 9.66212C22.3481 9.39212 21.9817 9.24023 21.6 9.24023H14.4C13.6047 9.24023 12.96 9.88499 12.96 10.6802V12.1202C12.96 12.502 13.1111 12.8691 13.3811 13.1391L15.84 15.5957ZM14.4 10.6801H21.6V12.1201L18.72 15.0001V18.6001L17.28 19.3201V15.0001L14.4 12.1201V10.6801Z",
    fill: "#3B3B4A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_8877",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223529 0 0 0 0 0.286275 0 0 0 0 0.329412 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_8877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_8877",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.59603175.svg";
export { ForwardRef as ReactComponent };